<template>
  <div class="customer-box">
    <el-select v-model="form.customerId" ref="customer-select" :placeholder="$attrs.placeholder ||`请选择操作人`" :filterable="true" :clearable="clearable"
      :filter-method="filterCustomer" @change="customerChange" @clear="clearCustomer" v-bind="$attrs" @visible-change="onVisibleChange" v-if="!multiple" @focus="selectFocus">
      <el-option v-for="item in users" :key="item[defaultProps.value]" :label="getLabelText(item)" :value="`${item[defaultProps.value]}`" :disabled="isDisabled(item)"></el-option>
    </el-select>
    <ybl-multi-select v-else v-model="form.customerId" :selectedAll="selectedAll" :selectText="selectText"
      @change="customerChange" :items="originUsers" :props="defaultProps" :placeholder="$attrs.placeholder ||`请选择操作人`"
      :label-select="true"
      class="el-select__small" :filterable="true" :clearable="!readonly" :readonly="readonly" :disableList="disableList"></ybl-multi-select>
  </div>
</template>

<script>
export default {
  name: 'yblCustomer',
  model: {
    prop: 'item',
    event: 'change'
  },
  props: {
    max: { // 最大显示条数
      type: String | Number,
      default: () => 20
    },
    item: {
      type: String | Number,
      default: () => ''
    },
    isPayee: { // 是否收款人
      type: Boolean,
      default: () => false
    },
    type: { // type:1 获取业务员 type：2获取出单员  type:null 获取全部人员
      type: String | Number,
      default: () => null
    },
    mountBody: { // 是否挂载在body节点上
      type: Boolean,
      default: () => true
    },
    multiple: { // 是否多选
      type: Boolean,
      default: () => false
    },
    clearable: {
      type: Boolean,
      default: () => true
    },
    selectedAll: { // 多选的场景 （是否全选）
      type: Boolean,
      default: () => false
    },
    selectText: { // 全选（文本配置）
      type: String,
      default: () => '全选'
    },
    data: { // 数据源
      type: Array,
      default: () => []
    },
    readonly: { // 是否只读
      type: Boolean,
      default: () => false
    },
    organizationId: { // 组织机构Id （用于组织详情查看）
      type: Number | String,
      default: () => ''
    },
    allowAdd: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    disableList: { // 禁用数据
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      originData: [], // 原始数据源
      originUsers: [],
      users: [],
      form: {
        customerId: ''
      },
      defaultProps: {
        label: 'Label',
        value: 'Value',
        alias: 'Title'
      }
    }
  },
  computed: {
    parsedDisableList () {
      if (!this.disableList || !this.disableList.length) return []
      let list = []
      this.disableList.forEach(item => {
        let val = item
        if (typeof item === 'object' && item !== null) {
          val = item.customerId || item.value || item.id
        }
        list.push(String(val))
        if (!isNaN(Number(val))) {
          list.push(Number(val))
        }
      })
      console.log(list)
      return list
    }
  },
  created () {
    if (this.isPayee) {
      this.defaultProps = {
        label: 'n',
        value: 'd',
        alias: 'gn'
      }
    }
    if (this.data && this.data.length === 0) {
      this.getData().then(() => {
        if (this.item) {
          this.form.customerId = Array.isArray(this.item) ? this.item : `${this.item}`
          if (this.multiple && !Array.isArray(this.item)) {
            this.form.customerId = this.item.split(',')
          }
        }
      })
    } else {
      this.originData = [...this.data]
      this.originUsers = [...this.data]
      this.initCustomer()
      if (this.item) {
        this.form.customerId = Array.isArray(this.item) ? this.item : `${this.item}`
        if (this.multiple && !Array.isArray(this.item)) {
          this.form.customerId = this.item.split(',')
        }
      }
    }
  },
  methods: {
    getCustomerList () {
      let params = {
        type: this.type
      }
      return this.$store.dispatch('customerGetSmallCustomer', params).then(data => {
        // console.log(data)
        let originData = data.datas// .filter(item => item.RealName)
        // this.originPayee = originData.filter(item => item.IsPayee)
        // let originUsers = originData// .filter(item => !item.IsPayee)
        this.originData = originData
        if (this.organizationId) {
          this.originUsers = originData.filter(item => `${item.OrganizationId}` === `${this.organizationId}`)
        } else {
          this.originUsers = originData
        }
        this.initCustomer()
      })
    },
    getCustomerContainOfficeType3 () {
      return this.$store.dispatch('customerGetCustomerContainOfficeType3', {}).then(data => {
        const originData = data.Customers
        this.originData = originData
        if (this.organizationId) {
          this.originUsers = originData.filter(item => `${item.g}` === `${this.organizationId}`)
        } else {
          this.originUsers = originData
        }

        this.initCustomer()
      })
    },
    getData () {
      if (this.isPayee) {
        return this.getCustomerContainOfficeType3()
      }
      return this.getCustomerList()
    },
    initCustomer () {
      /* if (this.isPayee) {
        this.originUsers = this.originUsers.filter(item => item.IsPayee)
      } */
      // 传值给parent组件 显示人员名称使用
      this.$emit('customer', this.originUsers)
      const {defaultProps: { value }} = this
      this.users = this.originUsers.filter((item, index) => index < +this.max)
      console.log(this.item)
      if (this.item) {
        const _items = Array.isArray(this.item) ? this.item : (this.multiple ? this.item.split(',') : [this.item])
        let _user = this.users.filter(item => `${item[value]}` === `${this.item}` || _items.includes(`${item[value]}`))
        console.log(_user)
        if (!_user || _user.length === 0 || _user.length < _items.length) {
          const exists = (_user && _user.map(item => `${item[value]}`)) || []
          let users = this.originUsers.filter(item => `${item[value]}` === `${this.item}` || (_items.includes(`${item[value]}`) && !exists.includes(`${item[value]}`)))
          this.users = [...this.users, ...users]
        }
      }
    },
    onVisibleChange (visible) {
      if (!this.allowAdd) {
        return
      }
      // 下拉隐藏时 取消焦点 解决下次获取焦点，不支持修改的问题
      if (!visible) {
        this.$refs['customer-select'].blur()
      }
    },
    selectFocus (e) {
      console.log('selectFocus', e.target.value)
      if (!this.allowAdd) {
        return
      }
      let value = e.target.value
      // 获取焦点后，填充输入框的值，支持修改输入框的值
      this.$nextTick(() => {
        let input = this.$refs['customer-select'].$children[0].$refs.input
        input.value = value
      })
    },
    filterCustomer (val) {
      if (val) {
        // val = val.toLowerCase()
        /* let users = this.originUsers.filter(item => {
          return item.RealName.toLowerCase().indexOf(val) !== -1 ||
            (item.Mobile || '').indexOf(val) !== -1 ||
            item.LoginName.toLowerCase().indexOf(val) !== -1 ||
            (item.CertificateNO || '').toLowerCase().indexOf(val) !== -1
        })
        this.users = users.reduce((sum, item) => {
          item.label = `${item.RealName}（${item.LoginName}）${item.OrganizationName} ${mobile(item.Mobile) || '-'}/${IdCard(item.CertificateNO) || '-'}`
          sum.push(item)
          return sum
        }, []) */
        const {defaultProps: { label, alias }} = this
        this.users = this.originUsers.filter(item => `${item[label]}${item[alias] || ''}`.toLowerCase().indexOf(val.toLowerCase()) !== -1)
        if (this.allowAdd) { // 过滤到有效数据，也支持编辑
          if (this.users.length === 0) { // 没有查到数据，显示前max条，处理编辑页不显示筛选项的问题(偶现)
            this.users = this.originUsers.filter((item, index) => index < +this.max)
          }
          this.$emit('change', val)
        }
      } else {
        if (this.allowAdd) {
          this.$emit('change', '') // 支持清空输入框内容 此事执行initCustomer无法清空
        } else {
          this.initCustomer()
        }
      }
    },
    customerChange (val) {
      const {defaultProps: { value }} = this
      if (this.multiple) {
        const items = this.originUsers.filter(item => val.includes(item[value]))
        this.$emit('change', val, val.length === this.originUsers.length, items) // 判断是否全选
        return
      }
      let item = this.users.find((c) => +c[value] === +val)
      this.$emit('change', val, item)
    },
    clearCustomer () {
      if (this.allowAdd) {
        this.$refs['customer-select'].$children[0].$refs.input.value = ''
      }
      this.initCustomer()
      // this.$emit('change', '')
    },
    getLabelText (item) {
      const { isPayee, defaultProps: { label, alias } } = this
      if (isPayee) {
        return `${item[label]} ${item[alias] || ''}`
      }
      return `${item[label]}`
    },
    isDisabled (item) {
      const value = String(item[this.defaultProps.value])
      return this.parsedDisableList.includes(value)
    }
  },
  watch: {
    'item': function (newVal, oldVal) {
      this.form.customerId = this.item
      if (this.multiple && !Array.isArray(this.item)) {
        this.form.customerId = (this.item && this.item.split(',')) || []
      }
      // item为文字的情况，走过滤逻辑
      if (this.allowAdd && /^[\u4e00-\u9fa5]+$/.test(newVal)) {
        this.filterCustomer(newVal)
      } else {
        this.initCustomer()
      }
    },
    'organizationId': function (newVal, oldVal) {
      if (!newVal) {
        this.originUsers = this.originData
        this.initCustomer()
        return
      }
      if (`${newVal}` !== `${oldVal}`) {
        this.originUsers = this.originData.filter(item => `${item.OrganizationId}` === `${newVal}`)
        this.initCustomer()
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Customer.vue